import { z } from 'zod';
import { handleSchema, moneySchema } from './primitives.js';
export const PRODUCT_STATUSES = ['DRAFT', 'ACTIVE', 'ARCHIVED'];
/**
 * Create payload.
 *
 * Note the absence of `tenantId`: the server takes it from the authenticated
 * session, never from the request body. Accepting it here would be the
 * mass-assignment hole that the tenant client exists to close.
 */
export const createProductSchema = z.object({
    title: z.string().min(1, 'Title is required').max(255),
    handle: handleSchema.optional(),
    description: z.string().max(50_000).optional(),
    status: z.enum(PRODUCT_STATUSES).default('DRAFT'),
    productType: z.string().max(255).optional(),
    vendor: z.string().max(255).optional(),
    tags: z.array(z.string().max(64)).max(50).default([]),
    price: moneySchema,
    sku: z.string().max(100).optional(),
    /** Starting stock at the tenant's default location. */
    quantity: z.coerce.number().int().min(0).default(0),
});
export const updateProductSchema = z.object({
    title: z.string().min(1).max(255).optional(),
    handle: handleSchema.optional(),
    description: z.string().max(50_000).nullable().optional(),
    status: z.enum(PRODUCT_STATUSES).optional(),
    productType: z.string().max(255).nullable().optional(),
    vendor: z.string().max(255).nullable().optional(),
    tags: z.array(z.string().max(64)).max(50).optional(),
});
export const listProductsQuerySchema = z.object({
    search: z.string().max(255).optional(),
    status: z.enum(PRODUCT_STATUSES).optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
// ── Variants ────────────────────────────────────────────────────────────────
/**
 * Price and stock live HERE, not on the product. A product-level price field
 * would silently mean "the first variant", which stops being true the moment a
 * product has more than one.
 */
export const createVariantSchema = z.object({
    title: z.string().min(1, 'Title is required').max(255),
    price: moneySchema,
    compareAtPrice: moneySchema.optional(),
    sku: z.string().max(100).optional(),
    barcode: z.string().max(100).optional(),
    quantity: z.coerce.number().int().min(0).default(0),
    trackInventory: z.boolean().default(true),
});
export const updateVariantSchema = z.object({
    title: z.string().min(1).max(255).optional(),
    price: moneySchema.optional(),
    compareAtPrice: moneySchema.nullable().optional(),
    sku: z.string().max(100).nullable().optional(),
    barcode: z.string().max(100).nullable().optional(),
    trackInventory: z.boolean().optional(),
});
/**
 * Stock adjustment.
 *
 * `onHand` is set absolutely rather than incremented: the admin UI shows a
 * number and the merchant types a new one, so a delta would race with any
 * concurrent order and silently drift.
 */
export const adjustInventorySchema = z.object({
    onHand: z.coerce.number().int().min(0),
});
//# sourceMappingURL=product.js.map